export const manifest = {
  screens: {
    scr_k2e092: { name: "Home", route: "/", state: {"view":"public"}, position: {"x":0,"y":0}, isDefaultRow: true },
    scr_dmqudy: { name: "Admin Login", route: "/", state: {"view":"login"}, position: {"x":160,"y":1820} },
    scr_1vn140: { name: "Admin Dashboard", route: "/", state: {"view":"admin"}, position: {"x":1560,"y":1820} },
  },
  sections: {
    sec_jmg9f9: { name: "Admin authentication flow", x: 0, y: 1600, width: 2920, height: 1180 },
  },
  layers: [
    { kind: "screen", id: "scr_k2e092" },
    { kind: "section", id: "sec_jmg9f9", children: [
      { kind: "screen", id: "scr_dmqudy" },
      { kind: "screen", id: "scr_1vn140" },
    ] },
  ],
}
